<template>
  <div class="search-bar">
    <form @submit.prevent="performSearch">
      <input type="search" name="q" v-model="searchQuery" :placeholder="loading ? '' : 'Search'" />
      <button class="clear-btn" type="button" v-if="searchQuery" @click="clearSearch">Clear</button>
    </form>
    <div v-if="results.length > 0" class="search-results">
      <ul>
        <li v-for="(result, index) in results" :key="index">
          <a :href="result.url">{{ result.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: false,
      searchQuery: '',
      results: [],
      debounceTimer: null,
    };
  },
  methods: {
    async performSearch() {
      if (!this.searchQuery) return;
      this.loading = true;

      try {
        // NOTE: add `&section=products` to only target products (instead of everything including blog posts, etc.)
        const response = await axios.get(`/api/entries.json?section=products&search=${encodeURIComponent(this.searchQuery)}`);

        if (response && response.data) {
          this.$emit('searchResults', response.data);
        }
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
      this.loading = false;
    },
    clearSearch() {
      this.searchQuery = '';
      this.results = [];
      this.$emit('clearSearch');
    },
    debounceSearch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.performSearch();
      }, 550);
    },
  },
  watch: {
    searchQuery(newQuery) {
      this.debounceSearch();
    },
  },
};
</script>